import { delegate } from '@coverright/utils';
import { logEvent } from './logEvent';
import { initTrackEvent } from './init-track-event';
import { subIdHandler } from './partner-params';

let listeners: any[] = [];

export function initAnalytics(projectName: string) {
  if (window) {
    initTrackEvent(projectName);
    setTimeout(subIdHandler, 1000)
    subscribeOnButtonClicks();
    subscribeOnLinksClicks();
  }
  return listeners;
}

export function unsubscribeFromEvents() {
  for (const listener of listeners) {
    document.removeEventListener('click', listener);
  }
  listeners = [];
}

function subscribeOnButtonClicks() {
  const listener = delegate(document, 'click', 'button', function (event) {
    logEvent('click',{
      event_type: 'click',
      element_title: event.target.textContent,
      element_id: event.target.id,
    });
  });
  listeners.push(listener);
}

function subscribeOnLinksClicks() {
  const listener = delegate(document, 'click', 'a', function (event) {
    const hrefElement = event.target.closest('a');
    if (hrefElement?.children.length === 1 && hrefElement.children[0].tagName === 'BUTTON') {
      return;
    }

    logEvent('click',{
      event_type: 'click',
      element_title: hrefElement.textContent,
      element_id: hrefElement.id,
    });
  });
  listeners.push(listener);
}
